import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';

const useStyles = makeStyles(theme => ({
	root: {
		paddingLeft: theme.spacing(1),
		paddingRight: theme.spacing(1),
		textTransform: 'inherit'
	},
	buttonLabelStyle: {
		fontWeight: '600',
		fontSize: '0.8rem'
	},
	startIcon: {
		// color: '#225bab'
		marginLeft: 0,
		marginRight: theme.spacing(0.5)
	},
	rootIconButton: {
		// paddingLeft: 0,
		padding: 0,
		width: '1rem',
		height: '1rem',
		color: 'inherit',
		'& path': {
			// fill: '#225bab'
		}
	},
	progressStyle: {
		marginLeft: 5,
		width: '1rem',
		height: '1rem',
		'& svg': {
			// width: '1.5rem',
			// height: '1.5rem'
		},
		color: theme.palette.background.paper
	}
}));

const GMButton = ({
	title,
	loading,
	onClick,
	color,
	variant,
	Icon,
	SvgIcon,
	start,
	titleAttr,
	...otherProps
}) => {
	// if (titleAttr === 'Drag Handler') {
	// 	console.log('GMButton', Icon?.type?.render?.muiName);
	// }

	const classes = useStyles();

	let startIcon = null;
	let endIcon = null;
	if (Icon) {
		// if (Icon.muiName || typeof Icon === 'function') {
		if (Icon?.type?.render?.muiName) {
			if (start) {
				startIcon = <Icon title={titleAttr} className={classes.rootIconButton} />;
			} else {
				endIcon = <Icon title={titleAttr} className={classes.rootIconButton} />;
			}
		} else {
			if (start) {
				startIcon = (
					<SvgIcon
						title={titleAttr}
						viewBox={Icon.viewBox}
						className={classes.rootIconButton}
					>
						{Icon.path}
					</SvgIcon>
				);
			} else {
				endIcon = (
					<SvgIcon
						title={titleAttr}
						viewBox={Icon.viewBox}
						className={classes.rootIconButton}
					>
						{Icon.path}
					</SvgIcon>
				);
			}
		}
	}

	if (SvgIcon) {
		startIcon = <SvgIcon className={classes.rootIconButton} {...otherProps} />;
	}

	// Text Button only
	if (!startIcon && !endIcon) {
		return (
			<Button
				variant={variant}
				classes={{
					root: classes.root,
					label: classes.buttonLabelStyle,
					startIcon: classes.startIcon
				}}
				color={color}
				title={title}
				onClick={onClick}
				{...otherProps}
			>
				<span>{title}</span>
				{loading && <CircularProgress size="1rem" className={classes.progressStyle} />}
			</Button>
		);
	}

	if (title) {
		// Button with Icon and Text
		return (
			<Button
				variant={variant}
				classes={{
					root: classes.root,
					label: classes.buttonLabelStyle,
					startIcon: classes.startIcon
				}}
				color={color}
				title={title}
				startIcon={startIcon}
				endIcon={endIcon}
				onClick={onClick}
				{...otherProps}
			>
				{title}
				{loading && <CircularProgress size="1rem" className={classes.progressStyle} />}
			</Button>
		);
	}
	// Button only Icon
	// if (titleAttr === 'Drag Handler') {
	// 	console.log('Button only Icon', { startIcon, endIcon });
	// }

	return (
		<IconButton
			classes={{ root: classes.rootIconButton, label: classes.buttonLabelStyle }}
			color="inherit"
			aria-label="button"
			onClick={onClick}
			title={titleAttr}
			{...otherProps}
		>
			{startIcon}
		</IconButton>
	);
};

GMButton.propTypes = {
	color: PropTypes.string,
	title: PropTypes.string,
	start: PropTypes.bool,
	onClick: PropTypes.func,
	variant: PropTypes.string,
	Icon: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
	SvgIcon: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
	titleAttr: PropTypes.string,
	loading: PropTypes.bool
};

GMButton.defaultProps = {
	start: true,
	color: 'inherit'
};

export default GMButton;
